import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningExamsBuilder(apiClient: AxiosInstance) {
  return async function getLearningExams(): Promise<
    ILearning.LearningFilterMenuItem[] | null
  > {
    try {
      const response = await apiClient.get("/learning/api/exams/");
      return response.data.results;
    } catch {
      return null;
    }
  };
}
